import React from 'react';
import '../template-file-css/document-file-template.css';


export const NP_PsychMed = ({ itemsRef, showErrorFor }) => {

    return (
        <form id='NP_PsychMed' className='file-pdf-document'>
            <div className='file-template'>

                <h2>Common Items</h2>
                <table>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Participant Accompanied By:</span></td>
                        <td className='w-375'><span className='eleHeader'>Legal Guardian/Custodian Name:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtParticipantAccompanied' name='txtParticipantAccompanied' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txLegalGuardian' name='txLegalGuardian' className='add-only' /> </td>
                    </tr>
                </table>
                <p className='w-750' >
                    <span className='small'>(check all that apply)</span>
                </p>
                <table>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbParticipant_1' name='cbParticipant_1' className='add-only' value='Self' /> Self
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbParticipant_2' name='cbParticipant_2' className='add-only' value='Family' /> Family
                        </td>

                        <td className='w-187'>
                            <input type='checkbox' id='cbParticipant_3' name='cbParticipant_3' className='add-only' value='Significant Other' /> Significant Other
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbParticipant_4' name='cbParticipant_4' className='add-only' value='Legal Guardian' /> Legal Guardian
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbParticipant_5' name='cbParticipant_5' className='add-only' value='Other' /> Other
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtOther' name='txtOther' className='add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>History of Present Problem(s):</span>
                    <span className='small'>(When began, duration/intensity of symptons, stressors/precipitants, list participants conception of presenting problems and what the participant perceives to be the important issues to be addressed.)</span>
                    <textarea id='txtHistoryofPresent' name='txtHistoryofPresent' className='add-only'></textarea>

                    <span className='eleHeader'>Prior MH/SA/DD History:</span>
                    <span className='small'>(Include residential treatment, inpatient, outpatient, etc.)</span>
                    <textarea id='txtPrior' name='txtPrior' className='add-only'></textarea>

                    <span className='eleHeader'>History of Traumatic Events:</span>
                    <span className='small'>(Consider neglect or abuse, violence, significant losses, accidents, etc.)</span>
                    <textarea id='txtHistoryofTraumatic' name='txtHistoryofTraumatic' className='add-only'></textarea>

                    <span className='eleHeader'>Current Living Situation:</span>
                    <span className='small'>(Where, with whom, relationship, etc.)</span>
                    <textarea id='txtCurrentLiving' name='txtCurrentLiving' className='add-only'></textarea>

                    <span className='eleHeader'>Education History:</span>
                    <span className='small'>(Consider special education, behavior programs, grade level current or achieved, school, attitude, etc.)</span>
                    <textarea id='txtEducationHistory' name='txtEducationHistory' className='add-only'></textarea>

                    <span className='eleHeader'>Vocational History:</span>
                    <span className='small'>(Include current Employment, military, vocational difficulties, handicaps, if unemployed - work plan, etc.)</span>
                    <textarea id='txtVocationalHistory' name='txtVocationalHistory' className='add-only'></textarea>

                    <span className='eleHeader'>Family History:</span>
                    <span className='small'>(Include any MH/DD/SA history of biological family, immediate family/significant others, diagnosis, treatment, etc.)</span>
                    <textarea id='txtFamilyHistory' name='txtFamilyHistory' className='add-only'></textarea>

                    <span className='eleHeader'>Social History:</span>
                    <span className='small'>(Include friendships, significant relationships, religious and cultural activities, hobbies, recreation)</span>
                    <textarea id='txtSocialHistory' name='txtSocialHistory' className='add-only'></textarea>

                    <span className='eleHeader'>Transcultural Factors:</span>
                    <textarea id='txtTransculturalFactors' name='txtTransculturalFactors' className='add-only'></textarea>

                    <span className='eleHeader'>Chief Concern:</span>
                    <textarea id='txtChiefConcern' name='txtChiefConcern' className='add-only'></textarea>

                    <span className='eleHeader'>History of Present Illness:</span>
                    <span className='small'>(Onset, Duration, Frequency of Symptoms, Previous Episodes, etc.)</span>
                    <textarea id='txtHistoryofPresentIllness' name='txtHistoryofPresentIllness' className='add-only'></textarea>

                </p>
                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>HISTORY OF SYMPTOMS: BEHAVIORAL/EMOTIONAL STATUS (INDIVIDUAL)</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='small'>Please check all of following that is typical:</span></td>
                    </tr>

                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbHISTORYOFSYMPTOMSt_1' name='cbHISTORYOFSYMPTOMSt_1' className='add-only' value='Aggressive' /> Aggressive
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbHISTORYOFSYMPTOMSt_2' name='cbHISTORYOFSYMPTOMSt_2' className='add-only' value='Frustrated easily' /> Frustrated easily
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbHISTORYOFSYMPTOMSt_3' name='cbHISTORYOFSYMPTOMSt_3' className='add-only' value='Crying' /> Sad/Crying
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbHISTORYOFSYMPTOMSt_4' name='cbHISTORYOFSYMPTOMSt_4' className='add-only' value='Truancy' /> Truancy
                        </td>
                    </tr>

                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbHISTORYOFSYMPTOMSt_5' name='cbHISTORYOFSYMPTOMSt_5' className='add-only' value='Mood Swings' /> Mood Swings
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbHISTORYOFSYMPTOMSt_6' name='cbHISTORYOFSYMPTOMSt_6' className='add-only' value='Angry' /> Angry
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbHISTORYOFSYMPTOMSt_7' name='cbHISTORYOFSYMPTOMSt_7' className='add-only' value='Anxiety' /> Anxiety
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbHISTORYOFSYMPTOMSt_8' name='cbHISTORYOFSYMPTOMSt_8' className='add-only' value='Hallucinations' /> Hallucinations
                        </td>
                    </tr>

                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbHISTORYOFSYMPTOMSt_9' name='cbHISTORYOFSYMPTOMSt_9' className='add-only' value='Head banging' /> Head banging
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbHISTORYOFSYMPTOMSt_10' name='cbHISTORYOFSYMPTOMSt_10' className='add-only' value='Fearful' />Fearful
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbHISTORYOFSYMPTOMSt_11' name='cbHISTORYOFSYMPTOMSt_11' className='add-only' value='PTSD' /> PTSD
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbHISTORYOFSYMPTOMSt_12' name='cbHISTORYOFSYMPTOMSt_12' className='add-only' value='Lies frequently' /> Lies frequently
                        </td>
                    </tr>

                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbHISTORYOFSYMPTOMSt_13' name='cbHISTORYOFSYMPTOMSt_13' className='add-only' value='Set fires' /> Set fires
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbHISTORYOFSYMPTOMSt_14' name='cbHISTORYOFSYMPTOMSt_14' className='add-only' value='Hurts animals' />Hurts animals
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbHISTORYOFSYMPTOMSt_15' name='cbHISTORYOFSYMPTOMSt_15' className='add-only' value='Avoids adults' /> Avoids adults
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbHISTORYOFSYMPTOMSt_16' name='cbHISTORYOFSYMPTOMSt_16' className='add-only' value='Loner' /> Loner
                        </td>
                    </tr>

                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbHISTORYOFSYMPTOMSt_17' name='cbHISTORYOFSYMPTOMSt_17' className='add-only' value='Imaginary friends' /> Imaginary friends
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbHISTORYOFSYMPTOMSt_18' name='cbHISTORYOFSYMPTOMSt_18' className='add-only' value='Sexual acting out' />Sexual acting out
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbHISTORYOFSYMPTOMSt_19' name='cbHISTORYOFSYMPTOMSt_19' className='add-only' value='Bedwetting' /> Bedwetting
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbHISTORYOFSYMPTOMSt_20' name='cbHISTORYOFSYMPTOMSt_20' className='add-only' value='Impulsive' /> Impulsive
                        </td>
                    </tr>

                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbHISTORYOFSYMPTOMSt_21' name='cbHISTORYOFSYMPTOMSt_21' className='add-only' value='Short attention span' /> Short attention span
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbHISTORYOFSYMPTOMSt_22' name='cbHISTORYOFSYMPTOMSt_22' className='add-only' value='Bizarre behavior' />Bizarre behavior
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbHISTORYOFSYMPTOMSt_23' name='cbHISTORYOFSYMPTOMSt_23' className='add-only' value='Irritable' /> Irritable
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbHISTORYOFSYMPTOMSt_24' name='cbHISTORYOFSYMPTOMSt_24' className='add-only' value='Running Away' /> Running Away
                        </td>
                    </tr>

                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbHISTORYOFSYMPTOMSt_25' name='cbHISTORYOFSYMPTOMSt_25' className='add-only' value='Hygiene/ADLs' /> Hygiene/ADLs
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbHISTORYOFSYMPTOMSt_26' name='cbHISTORYOFSYMPTOMSt_26' className='add-only' value='Speech problems' />Speech problems
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbHISTORYOFSYMPTOMSt_27' name='cbHISTORYOFSYMPTOMSt_27' className='add-only' value='Careless, reckless' /> Careless, reckless
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbHISTORYOFSYMPTOMSt_28' name='cbHISTORYOFSYMPTOMSt_28' className='add-only' value='Bullies, threatens' /> Bullies, threatens
                        </td>
                    </tr>

                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbHISTORYOFSYMPTOMSt_29' name='cbHISTORYOFSYMPTOMSt_29' className='add-only' value=' Learning problems' /> Learning problems
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbHISTORYOFSYMPTOMSt_30' name='cbHISTORYOFSYMPTOMSt_30' className='add-only' value='Steals' />Steals
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbHISTORYOFSYMPTOMSt_31' name='cbHISTORYOFSYMPTOMSt_31' className='add-only' value='Suicidal threats' /> Suicidal threats
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbHISTORYOFSYMPTOMSt_32' name='cbHISTORYOFSYMPTOMSt_32' className='add-only' value=' Low self-esteem' /> Low self-esteem
                        </td>
                    </tr>

                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbHISTORYOFSYMPTOMSt_33' name='cbHISTORYOFSYMPTOMSt_33' className='add-only' value='Hygiene/ADLs' /> Hyperactivity
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbHISTORYOFSYMPTOMSt_34' name='cbHISTORYOFSYMPTOMSt_34' className='add-only' value='Speech problems' />Talks back
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbHISTORYOFSYMPTOMSt_35' name='cbHISTORYOFSYMPTOMSt_35' className='add-only' value='Careless, reckless' />Impulse Control
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbHISTORYOFSYMPTOMSt_36' name='cbHISTORYOFSYMPTOMSt_36' className='add-only' value='Bullies, threatens' /> Nightmares
                        </td>
                    </tr>

                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbHISTORYOFSYMPTOMSt_37' name='cbHISTORYOFSYMPTOMSt_37' className='add-only' value='Defiant' /> Defiant
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbHISTORYOFSYMPTOMSt_38' name='cbHISTORYOFSYMPTOMSt_38' className='add-only' value='Destructive' />Destructive
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbHISTORYOFSYMPTOMSt_39' name='cbHISTORYOFSYMPTOMSt_39' className='add-only' value='Oppositional' />Oppositional
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbHISTORYOFSYMPTOMSt_40' name='cbHISTORYOFSYMPTOMSt_40' className='add-only' value='Panic attacks' /> Panic attacks
                        </td>
                    </tr>

                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbHISTORYOFSYMPTOMSt_41' name='cbHISTORYOFSYMPTOMSt_41' className='add-only' value='Drugs dependence' />Drugs dependence
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbHISTORYOFSYMPTOMSt_42' name='cbHISTORYOFSYMPTOMSt_42' className='add-only' value='Phobias' />Phobias
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbHISTORYOFSYMPTOMSt_43' name='cbHISTORYOFSYMPTOMSt_43' className='add-only' value='Loss of Energy/Interests' /> Loss of Energy/Interests
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbHISTORYOFSYMPTOMSt_44' name='cbHISTORYOFSYMPTOMSt_44' className='add-only' value='Other Concerns' /> Other Concerns
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'><span className='small'>(specify):</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txOtherConcerns' name='txOtherConcerns' className='add-only' /> </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>MEDICATION HISTORY:</span>
                    <textarea id='txtMEDICATIONHISTORY' name='txtMEDICATIONHISTORY' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbMEDICATIONHISTORY_1' name='cbMEDICATIONHISTORY_1' className='add-only' value='None reported' /> None reported
                        </td>
                    </tr>

                    <tr>
                        <td className='w-187'><span className='eleHeader'>MEDICATION</span></td>
                        <td className='w-187'><span className='eleHeader'>DOSAGE</span></td>
                        <td className='w-187'><span className='eleHeader'>DATE START/ LAST USE</span></td>
                        <td className='w-187'><span className='eleHeader'>COMPLIANT</span></td>
                    </tr>

                    <tr>
                        <td className='w-187'> <input type='text' id='txtMEDICATION_1' name='txtMEDICATION_1' className='add-only' /> </td>
                        <td className='w-187'> <input type='text' id='txtDOSAGE_1' name='txtDOSAGE_1' className='add-only' /> </td>
                        <td className='w-187'> <input type='date' id='txtDATESTARTLASTUSE_1' name='txtDATESTARTLASTUSE_1' className='add-only' /> </td>
                        <td className='w-187'> <input type='text' id='txtCOMPLIANT_1' name='txtCOMPLIANT_1' className='add-only' /> </td>
                    </tr>

                    <tr>
                        <td className='w-187'> <input type='text' id='txtMEDICATION_2' name='txtMEDICATION_2' className='add-only' /> </td>
                        <td className='w-187'> <input type='text' id='txtDOSAGE_2' name='txtDOSAGE_2' className='add-only' /> </td>
                        <td className='w-187'> <input type='date' id='txtDATESTARTLASTUSE_2' name='txtDATESTARTLASTUSE_2' className='add-only' /> </td>
                        <td className='w-187'> <input type='text' id='txtCOMPLIANT_2' name='txtCOMPLIANT_2' className='add-only' /> </td>
                    </tr>

                    <tr>
                        <td className='w-187'> <input type='text' id='txtMEDICATION_3' name='txtMEDICATION_3' className='add-only' /> </td>
                        <td className='w-187'> <input type='text' id='txtDOSAGE_3' name='txtDOSAGE_3' className='add-only' /> </td>
                        <td className='w-187'> <input type='date' id='txtDATESTARTLASTUSE_3' name='txtDATESTARTLASTUSE_3' className='add-only' /> </td>
                        <td className='w-187'> <input type='text' id='txtCOMPLIANT_3' name='txtCOMPLIANT_3' className='add-only' /> </td>
                    </tr>

                    <tr>
                        <td className='w-187'> <input type='text' id='txtMEDICATION_4' name='txtMEDICATION_4' className='add-only' /> </td>
                        <td className='w-187'> <input type='text' id='txtDOSAGE_4' name='txtDOSAGE_4' className='add-only' /> </td>
                        <td className='w-187'> <input type='date' id='txtDATESTARTLASTUSE_4' name='txtDATESTARTLASTUSE_4' className='add-only' /> </td>
                        <td className='w-187'> <input type='text' id='txtCOMPLIANT_4' name='txtCOMPLIANT_4' className='add-only' /> </td>
                    </tr>

                    <tr>
                        <td className='w-187'> <input type='text' id='txtMEDICATION_5' name='txtMEDICATION_5' className='add-only' /> </td>
                        <td className='w-187'> <input type='text' id='txtDOSAGE_5' name='txtDOSAGE_5' className='add-only' /> </td>
                        <td className='w-187'> <input type='date' id='txtDATESTARTLASTUSE_5' name='txtDATESTARTLASTUSE_5' className='add-only' /> </td>
                        <td className='w-187'> <input type='text' id='txtCOMPLIANT_5' name='txtCOMPLIANT_5' className='add-only' /> </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Assessment:</span>
                    <span className='small'>(Strengths, Assets, Formulation)</span>
                    <textarea id='txtAssessment' name='txtAssessment' className='add-only'></textarea>
                </p>

                <h2>EVALUATION OF RISK TO SELF OR OTHERS:</h2>

                <p className='w-750'>
                    <span className='eleHeader'>History of Suicidal/Homicidal Risk:</span>
                    <textarea id='txtHomicidalRisk' name='txtHomicidalRisk' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-375'> <input type='checkbox' id='txtHomicidalRisk_1' name='txtHomicidalRisk_1' className='add-only' value='None reported' /> None reported </td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='txtHomicidalRisk_2' name='txtHomicidalRisk_2' className='add-only' value='Suicidal Ideation' /> Suicidal Ideation </td>
                        <td className='w-187'><input type='checkbox' id='txtHomicidalRisk_3' name='txtHomicidalRisk_2' className='add-only' value='Suicidal Attempt' /> Suicidal Attempt </td>
                        <td className='w-187'><input type='checkbox' id='txtHomicidalRisk_4' name='txtHomicidalRisk_3' className='add-only' value='Suicidal Threats' /> Suicidal Threats </td>
                        <td className='w-187'><input type='checkbox' id='txtHomicidalRisk_5' name='txtHomicidalRisk_4' className='add-only' value='Self Injurious Behavior' /> Self Injurious Behavior </td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='txtHomicidalRisk_6' name='txtHomicidalRisk_6' className='add-only' value='History of Serious Physical Harm to Self' /> History of Serious Physical Harm to Self</td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Describe history of risk behaviors:</span>
                    <textarea id='txtDescribehistory' name='txtDescribehistory' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='txtDescribehistory_1' name='txtDescribehistory_1' className='add-only' value='Homicidal Ideation' /> Homicidal Ideation </td>
                        <td className='w-187'><input type='checkbox' id='txtDescribehistory_2' name='txtDescribehistory_2' className='add-only' value='Homicidal Attempts' /> Homicidal Attempts</td>
                        <td className='w-187'><input type='checkbox' id='txtDescribehistory_3' name='txtDescribehistory_3' className='add-only' value='Homicidal Threats' /> Homicidal Threats </td>
                        <td className='w-187'><input type='checkbox' id='txtDescribehistory_4' name='txtDescribehistory_4' className='add-only' value='Serious Lethal Intent' /> Serious Lethal Intent</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='txtDescribehistory_5' name='txtDescribehistory_5' className='add-only' value='History of Serious Physical Harm to others While in Treatment' /> History of Serious Physical Harm to others While in Treatment</td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Describe history of risk behaviors:</span>
                    <textarea id='txtriskbehaviors' name='txtriskbehaviors' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='txtriskbehaviors_1' name='txtriskbehaviors_1' className='add-only' value='Persistent/Repetitive' /> Persistent/Repetitive </td>
                        <td className='w-187'><input type='checkbox' id='txtriskbehaviors_2' name='txtriskbehaviors_2' className='add-only' value=' Has a Plan' /> Has a Plan </td>
                        <td className='w-250'><input type='checkbox' id='txtriskbehaviors_3' name='txtriskbehaviors_3' className='add-only' value='Delusional/Psychotic in Content ' /> Delusional/Psychotic in Content </td>
                    </tr>
                </table>

                <h2>Summary of Risk Evaluation:</h2>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Suicidal Risk is:</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='radio' id='rbSuicidalRisk_low' name='rbLow' className='add-only' value='Low to None' /> Low to None
                        </td>
                        <td className='w-187'>
                            <input type='radio' id='rbSuicidalRisk_Moderate' name='rbModerate' className='add-only' value='Moderate' /> Moderate
                        </td>
                        <td className='w-187'>
                            <input type='radio' id='rbSuicidalRisk_Imminent' name='rbImminent' className='add-only' value='Imminent' /> Imminent
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'><span className='eleHeader'>Homicidal Risk is:</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='radio' id='rbSuicidalRisk_low_1' name='rbLow_1' className='add-only' value='Low to None' /> Low to None
                        </td>
                        <td className='w-187'>
                            <input type='radio' id='rbSuicidalRisk_Moderate_1' name='rbModerate_1' className='add-only' value='Moderate' /> Moderate
                        </td>
                        <td className='w-187'>
                            <input type='radio' id='rbSuicidalRisk_Imminent_1' name='rbImminent_1' className='add-only' value='Imminent' /> Imminent
                        </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Plan for Work Up and Treatment:</span>
                    <span className='small'>(Rx's, Services, Drug Screens, Standing Orders, etc.)</span>
                    <textarea id='txtPlanforWork' name='txtPlanforWork' className='add-only'></textarea>
                </p>

                <h2>BEHAVIOR OBSERVATIONS: (FACETOFACE)</h2>
                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Mental Status:</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='txtMentalStatus_1' name='txtMentalStatus_1' className='add-only' value='Alert' /> Alert  </td>
                        <td className='w-187'><input type='checkbox' id='txtMentalStatus_2' name='txtMentalStatus_2' className='add-only' value='Oriented to:' /> Oriented to: </td>
                        <td className='w-187'><input type='checkbox' id='txtMentalStatus_3' name='txtMentalStatus_3' className='add-only' value='Person' /> Person </td>
                    </tr>

                    <tr>
                        <td className='w-187'><input type='checkbox' id='txtMentalStatus_4' name='txtMentalStatus_4' className='add-only' value='Alert' /> Alert  </td>
                        <td className='w-187'><input type='checkbox' id='txtMentalStatus_5' name='txtMentalStatus_5' className='add-only' value='Oriented to:' /> Oriented to: </td>
                        <td className='w-187'><input type='checkbox' id='txtMentalStatus_6' name='txtMentalStatus_6' className='add-only' value='Person' /> Person </td>
                    </tr>

                    <tr>
                        <td className='w-750'><span className='eleHeader'>Appearance:</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='txtAppearance_1' name='txtAppearance_1' className='add-only' value='Disheveled' /> Disheveled  </td>
                        <td className='w-187'><input type='checkbox' id='txtAppearance_2' name='txtAppearance_2' className='add-only' value='Casual' /> Casual  </td>
                        <td className='w-187'><input type='checkbox' id='txtAppearance_3' name='txtAppearance_3' className='add-only' value='Age Appropriate' /> Age Appropriate </td>
                    </tr>

                    <tr>
                        <td className='w-750'><span className='eleHeader'>Hygiene:</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='radio' id='rbHygiene_Good' name='rbGood' className='add-only' value='Good' /> Good </td>
                        <td className='w-187'>
                            <input type='radio' id='rbHygiene_Fair' name='rbFair' className='add-only' value='Fair' /> Fair</td>
                        <td className='w-187'>
                            <input type='radio' id='rbHygiene_Poor' name='rbPoor' className='add-only' value='Poor' /> Poor </td>
                    </tr>

                    <tr>
                        <td className='w-750'><span className='eleHeader'>Posture:</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='txtPosture_1' name='txtPosture_1' className='add-only' value='Relaxed' /> Relaxed  </td>
                        <td className='w-187'><input type='checkbox' id='txtPosture_2' name='txtPosture_2' className='add-only' value='Erect' /> Erect  </td>
                        <td className='w-187'><input type='checkbox' id='txtPosture_3' name='txtPosture_3' className='add-only' value='Slouched' /> Slouched </td>
                        <td className='w-187'><input type='checkbox' id='txtPosture_4' name='txtPosture_4' className='add-only' value='Pacing' />  Pacing </td>
                    </tr>

                    <tr>
                        <td className='w-750'><span className='eleHeader'>Eye Contact:</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='txtEyeContact_1' name='txtEyeContact_1' className='add-only' value='Appropriate' /> Appropriate </td>
                        <td className='w-187'><input type='checkbox' id='txtEyeContact_2' name='txtEyeContact_2' className='add-only' value='Poor' />  Poor</td>
                    </tr>


                    <tr>
                        <td className='w-750'><span className='eleHeader'>Primary Facial Expression:</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='txtPrimaryFacial_1' name='txtPrimaryFacial_1' className='add-only' value='Appropriate' /> Appropriate  </td>
                        <td className='w-187'><input type='checkbox' id='txtPrimaryFacial_2' name='txtPrimaryFacial_2' className='add-only' value='Sad' /> Sad   </td>
                        <td className='w-187'><input type='checkbox' id='txtPrimaryFacial_3' name='txtPrimaryFacial_3' className='add-only' value='Happy' /> Happy  </td>
                        <td className='w-187'><input type='checkbox' id='txtPrimaryFacial_4' name='txtPrimaryFacial_4' className='add-only' value='Elated' />  Elated </td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='txtPrimaryFacial_5' name='txtPrimaryFacial_5' className='add-only' value='Worried' />  Worried</td>
                    </tr>

                    <tr>
                        <td className='w-750'><span className='eleHeader'>Affect:</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='txtAffect_1' name='txtAffect_1' className='add-only' value='Calm' /> Calm  </td>
                        <td className='w-187'><input type='checkbox' id='txtAffect_2' name='txtAffect_2' className='add-only' value='Optimistic' /> Optimistic  </td>
                        <td className='w-187'><input type='checkbox' id='txtAffect_3' name='txtAffect_3' className='add-only' value='Cheerful' /> Cheerful   </td>
                        <td className='w-187'><input type='checkbox' id='txtAffect_4' name='txtAffect_4' className='add-only' value='Anxious' />  Anxious </td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='txtAffect_5' name='txtAffect_5' className='add-only' value='Pessimistic' />Pessimistic  </td>
                        <td className='w-187'><input type='checkbox' id='txtAffect_6' name='txtAffect_6' className='add-only' value='Fearful' /> Fearful   </td>
                        <td className='w-187'><input type='checkbox' id='txtAffect_7' name='txtAffect_7' className='add-only' value='Neutral' /> Neutral  </td>
                        <td className='w-187'><input type='checkbox' id='txtAffect_8' name='txtAffect_8' className='add-only' value='Blunted' />  Blunted  </td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='txtAffect_9' name='txtAffect_9' className='add-only' value='Depressed' />Depressed </td>
                        <td className='w-187'><input type='checkbox' id='txtAffect_10' name='txtAffect_10' className='add-only' value='Tearful' /> Tearful   </td>
                        <td className='w-187'><input type='checkbox' id='txtAffect_11' name='txtAffect_11' className='add-only' value='Irritable' /> Irritable </td>
                        <td className='w-187'><input type='checkbox' id='txtAffect_12' name='txtAffect_12' className='add-only' value='Flat' />  Flat </td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='txtAffect_13' name='txtAffect_13' className='add-only' value='Angry' />Angry </td>
                        <td className='w-187'><input type='checkbox' id='txtAffect_14' name='txtAffect_14' className='add-only' value='Euphoric' /> Euphoric </td>
                        <td className='w-187'><input type='checkbox' id='txtAffect_15' name='txtAffect_15' className='add-only' value='Elated' /> Elated </td>
                        <td className='w-187'><input type='checkbox' id='txtAffect_16' name='txtAffect_16' className='add-only' value='Labile' /> Labile </td>
                    </tr>

                    <tr>
                        <td className='w-750'><span className='eleHeader'>Judgment:</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='radio' id='rbJudgment_Good' name='rbGood_1' className='add-only' value='Good' /> Good  </td>
                        <td className='w-187'>
                            <input type='radio' id='rbJudgment_Fair' name='rbFair_1' className='add-only' value='Fair' /> Fair </td>
                        <td className='w-187'>
                            <input type='radio' id='rbJudgment_Poor' name='rbPoor_1' className='add-only' value='Poor' /> Poor  </td>
                    </tr>

                    <tr>
                        <td className='w-750'><span className='eleHeader'>Insight:</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='radio' id='rbInsight_Good' name='rbGood_2' className='add-only' value='Low to None' /> Good </td>
                        <td className='w-187'>
                            <input type='radio' id='rbInsight_Fair' name='rbFair_2' className='add-only' value='Low to None' /> Fair  </td>
                        <td className='w-187'>
                            <input type='radio' id='rbInsight_Poor' name='rbPoor_2' className='add-only' value='Low to None' />Poor </td>
                    </tr>

                    <tr>
                        <td className='w-750'><span className='eleHeader'>Memory:</span></td>
                        <td className='w-187'><b>Recent:</b> </td>
                        <td className='w-187'>
                            <input type='radio' id='rbMemory_Good_1' name='rbGood_3' className='add-only' value='Low to None' /> Good </td>
                        <td className='w-187'>
                            <input type='radio' id='rbMemory_Fair_1' name='rbFair_3' className='add-only' value='Low to None' /> Fair  </td>
                        <td className='w-187'>
                            <input type='radio' id='rbMemory_Poor_1' name='rbPoor_3' className='add-only' value='Low to None' />Poor </td>
                    </tr>

                    <tr>
                        <td className='w-187'><b>Remote:</b> </td>
                        <td className='w-187'>
                            <input type='radio' id='rbMemory_Poor_2' name='rbGood_4' className='add-only' value='Low to None' /> Good </td>
                        <td className='w-187'>
                            <input type='radio' id='rbMemory_Poor_2' name='rbFair_4' className='add-only' value='Low to None' /> Fair  </td>
                        <td className='w-187'>
                            <input type='radio' id='rbMemory_Poor_3' name='rbPoor_4' className='add-only' value='Low to None' />Poor </td>
                    </tr>
                </table>

                <h2>Diagnosis</h2>
                <table>

                    <tr>
                        <td className='w-50'><span className='eleHeader'>#</span></td>
                        <td className='w-500'><span className='eleHeader'>Diagnosis</span></td>
                        <td className='w-200'><span className='eleHeader'>Date</span></td>
                    </tr>
                    <tr>
                        <td className='w-50'> <input type='text' id='txtNumber_1' name='txtNumber_1' className='add-only' /> </td>
                        <td className='w-500'> <input type='text' id='txtDiagnosis_1' name='txtDiagnosis_1' className='add-only' /> </td>
                        <td className='w-200'> <input type='date' id='txtDateE_1' name='txtDateE_1' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-50'> <input type='text' id='txtNumber_2' name='txtNumber_2' className='add-only' /> </td>
                        <td className='w-500'> <input type='text' id='txtDiagnosis_2' name='txtDiagnosis_2' className='add-only' /> </td>
                        <td className='w-200'> <input type='date' id='txtDateE_2' name='txtDateE_2' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-50'> <input type='text' id='txtNumber_3' name='txtNumber_3' className='add-only' /> </td>
                        <td className='w-500'> <input type='text' id='txtDiagnosis_3' name='txtDiagnosis_3' className='add-only' /> </td>
                        <td className='w-200'> <input type='date' id='txtDateE_3' name='txtDateE_3' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-50'> <input type='text' id='txtNumber_4' name='txtNumber_4' className='add-only' /> </td>
                        <td className='w-500'> <input type='text' id='txtDiagnosis_4' name='txtDiagnosis_4' className='add-only' /> </td>
                        <td className='w-200'> <input type='date' id='txtDateE_4' name='txtDateE_4' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-50'> <input type='text' id='txtNumber_5' name='txtNumber_5' className='add-only' /> </td>
                        <td className='w-500'> <input type='text' id='txtDiagnosis_5' name='txtDiagnosis_5' className='add-only' /> </td>
                        <td className='w-200'> <input type='date' id='txtDateE_5' name='txtDateE_5' className='add-only' /> </td>
                    </tr>

                    <p className='w-750'>
                        <span className='eleHeader'>Assessment History</span>
                        <textarea id='txtAssessmentHistory' name='txtAssessmentHistory' className='add-only'></textarea>
                    </p>



                </table>

            </div>
        </form>

    )
}